import {
  GET_LAYOUT_MAX_WIDTH,
  GET_LIST_ITEM_NUM,
} from '../../constants/layout';
import { HEADER_KEYS, HeaderItems } from './headerItems';
import styles from './styles';

export const getListItemStyle = (itemIndex: number) => {
  const numColumns = GET_LIST_ITEM_NUM();
  const isLeft = itemIndex % numColumns === 0;
  const isRight = itemIndex % numColumns === numColumns - 1;

  switch (true) {
    case isLeft:
      return styles.listLeftItem;
    case isRight:
      return styles.listRightItem;
    default:
      return styles.listItem;
  }
};

type GetPitNumberAtTheSection = (args: {
  item: string;
  indexInFlatList: number;
  headerStartIndex: Record<string, number>;
}) => number;

export const getPitNumberAtTheSection: GetPitNumberAtTheSection = args => {
  const { item, indexInFlatList, headerStartIndex } = args;
  const theSection = /^promote-/i.test(item)
    ? HeaderItems.PromoteItems
    : HeaderItems.SpecialForYouList;
  const theStartIndex = headerStartIndex[theSection];

  return indexInFlatList - theStartIndex;
};

export const getItemBaseWidth = (itemMargin: number) => {
  const containerWidth = GET_LAYOUT_MAX_WIDTH() - itemMargin * 2;

  return containerWidth / GET_LIST_ITEM_NUM();
};

export const checkShouldImpression = (itemName: string) => {
  const ignoreImpression = HEADER_KEYS.includes(itemName);

  if (!itemName || ignoreImpression || /blank|none/gi.test(itemName)) {
    return false;
  }

  return true;
};
